import Mock from "../mock";

const database = {
  information: {
    name: "Brandon Cansdale",
    aboutContent:
        "I’m a full-stack web developer who specializes in writing clean, efficient code and crafting pixel-perfect designs. I focus on building responsive, user-friendly websites with smooth, engaging animations to enhance interactivity and user experience.",
    age: 30,
    phone: "",
    nationality: "American",
    language: "English",
    email: "brandon.cansdale@phaseonemedia.io",
    address: "Salt Lake City, UT, United States",
    freelanceStatus: "Available",
    socialLinks: {
      facebook: "",
      instagram: "https://www.instagram.com/hoursondeck/",
      youtube: "https://www.youtube.com/@HoursonDeckAviation",
      tiktok: "https://www.tiktok.com/@codeculture._?lang=en",
      twitter: "https://x.com/hoursondeck",
      pinterest: "",
      behance: "",
      linkedin: "https://linkedin.com/in/brandon-c-cansdale/",
      dribbble: "",
      github: "https://github.com/Bcansdale",
      upwork: "https://www.upwork.com/freelancers/~01a38c2e1552d09b0e?mp_source=share"
    },
    brandImage: "/images/resumePhotoCir-1.jpg",
    aboutImage: "/images/aviation.jpg",
    aboutImageLg: "/images/about-image-lg.jpg",
    cvfile: "/files/brandonCCVResume6-16.pdf",
  },
  services: [
    {
      title: "Web & Graphic Design",
      icon: "brush-alt",
      details:
          "I design sleek, modern, and user-friendly websites and graphics that make your brand stand out. Whether you need a website revamp, a fresh logo, or custom visuals, I ensure your online presence is both stunning and effective at converting visitors into customers.",
    },
    {
      title: "Web Development",
      icon: "code",
      details:
          "I develop fast, secure, and fully responsive websites tailored to your business needs. Whether it's a custom-coded solution or a CMS like WordPress, I build high-performance websites that enhance your digital presence and drive growth.",
    },
    {
      title: "Digital Marketing & SEO",
      icon: "seo",
      details:
          "I help businesses improve their search rankings and drive targeted traffic with strategic SEO and digital marketing techniques. From keyword optimization to content marketing, I ensure your business attracts and retains the right audience for long-term success.",
    },
    {
      title: "Social Media Marketing",
      icon: "laptop",
      details:
          "I create engaging content and targeted ad campaigns to grow your brand on social media. Whether it's Instagram, Facebook, LinkedIn, or Twitter, I help businesses increase engagement, build brand awareness, and turn followers into loyal customers.",
    },
    {
      title: "E-Commerce Development",
      icon: "cart",
      details:
          "I build fully optimized and high-converting e-commerce websites that help you sell more online. From Shopify to WooCommerce and custom-built stores, I ensure your platform is user-friendly, secure, and designed to maximize sales.",
    },
    {
      title: "Brand Strategy & Consulting",
      icon: "bulb",
      details:
          "I help businesses develop a strong, consistent brand identity that sets them apart from the competition. From messaging and positioning to visual branding, I work with you to create a strategy that resonates with your audience and drives business growth.",
    },
    {
      title: "Photography",
      icon: "camera",
      details:
          "I offer professional photography services tailored to elevate your brand’s visual impact. Whether you need product shots, lifestyle imagery, business headshots, or event coverage, I deliver high-quality photos that capture your message and resonate with your audience. Sharp visuals are key to standing out — let’s create imagery that speaks volumes.",
    },
    {
      title: "CFI, CFII, MEI - Coming Soon",
      icon: "cloudy-sun",
      details:
          "Soon offering expert flight instruction for aspiring aviators. Whether you’re beginning your journey with a Private Pilot License, advancing with an Instrument Rating, or training for multi-engine operations, I’ll provide focused, safety-first instruction as a Certified Flight Instructor (CFI), Instrument Instructor (CFII), and Multi-Engine Instructor (MEI). Ground and in-flight training tailored to help you succeed with skill and confidence.",
    },
  ],

  reviews: [
    {
      id: 1,
      content:
          "Brandon is a top-notch freelancer and a pleasure to work with! He has good knowledge of SEO fundamentals and is eager to do more. Throughout the project he completed any of the tasks I sent him within my deadlines and communicated clearly. He even took the initiative to fix errors in some content that I did not notice. I will definitely hire him again.",
      author: {
        name: "Nick Bonamer",
        designation: "PureForm",
      },
    },
    {
      id: 2,
      content:
          "Brandon over-delivered on my project. He was very responsive, and was able to complete the project in a timely manner. I would definitely work with him again!",
      author: {
        name: "Ben Stanczik",
        designation: "Ridiculous Media",
      },
    },
    // {
    //   id: 3,
    //   content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
    //   author: {
    //     name: "Irving Feeney",
    //     designation: "Fiverr Client",
    //   },
    // },
  ],

  // skills: [
  //   {
  //     title: "HTML5",
  //     value: 95,
  //   },
  //   {
  //     title: "CSS3",
  //     value: 90,
  //   },
  //   {
  //     title: "Javascript",
  //     value: 70,
  //   },
  //   {
  //     title: "jQuery",
  //     value: 85,
  //   },
  //   {
  //     title: "ReactJS",
  //     value: 80,
  //   },
  //   {
  //     title: "Photoshop",
  //     value: 65,
  //   },
  // ],

  skills: [
    {
      name: "HTML5",
      icon: "html5-plain",
    },
    {
      name: "CSS3",
      icon: "css3-plain",
    },
    {
      name: "Tailwind CSS",
      icon: "tailwindcss-plain",
    },
    {
      name: "Bootstrap",
      icon: "bootstrap-plain",
    },
    {
      name: "JavaScript",
      icon: "javascript-plain",
    },
    {
      name: "React",
      icon: "react-original",
    },
    {
      name: "Node.js",
      icon: "nodejs-plain-wordmark",
    },
    {
      name: "Express.js",
      icon: "express-original",
    },
    {
      name: "Next.js",
      icon: "nextjs-plain",
    },
    {
      name: "MongoDB",
      icon: "mongodb-plain-wordmark",
    },
    {
      name: "PostgreSQL",
      icon: "postgresql-plain",
    },
    {
      name: "Sequelize",
      icon: "sequelize-plain",
    },
    {
      name: "Laravel",
      icon: "laravel-plain",
    },
    {
      name: "PHP",
      icon: "php-plain",
    },
    {
      name: "Git",
      icon: "git-plain",
    },
    {
      name: "Wordpress",
      icon: "wordpress-plain",
    },
  ],

  portfolios: [
    {
      id: 1,
      title: "Force Fitness",
      subtitle: "Gym website ",
      imageUrl: "/images/forceFitness.jpg",
      largeImageUrl: ["/images/forceFitness.png"],
      url: "https://forcefitnesslegacy.com/",
    },
    {
      id: 2,
      title: "StarBro AI - Coming Soon",
      subtitle: "Scheduling platform with AI image and text generation. Full payment integration with stripe.",
      imageUrl: "/images/starbroDashboard.jpg",
      largeImageUrl: ["/images/starbroDashboard.png",
        "/images/starbroGallery.png",
        "/images/starbroImgGen.png",
        "/images/starbroCharacters.png",
        "/images/starbroCharacterTrain.png",
        "/images/starbroScheduler.png",
        "/images/starbroTextGen.png"],
      url: "",
    },
    {
      id: 3,
      title: "WarmTemps Blog",
      subtitle: "Wordpress blog built onto main website",
      imageUrl: "/images/warmtempsBlog.jpg",
      largeImageUrl: ["/images/warmtempsBlog.png"],
      url: "https://www.warmtemps.com/blog",
    },
    {
      id: 4,
      title: "WarmTemps Shop",
      subtitle: "Shopify store built onto main website",
      imageUrl: "/images/warmtempsShop.jpg",
      largeImageUrl: ["/images/warmtempsShop.png"],
      url: "https://shop.warmtemps.com/collections/all"
    },
    {
      id: 5,
      title: "WarmTemps Main",
      subtitle: "SEO focused informational website built using HTML, CSS, JS, PHP, and Bootstrap",
      imageUrl: "/images/warmtempsMain.jpg",
      largeImageUrl: ["/images/warmtempsMain.png"],
      url: "https://www.warmtemps.com/",
    },
    {
      id: 6,
      title: "SanCap Gateway",
      subtitle: "Real estate website for Sanibel Captiva Gateway Realty.",
      imageUrl: "/images/sancapGateway.jpg",
      largeImageUrl: ["/images/sancapGateway.png"],
      url: "https://www.sancapgateway.com",
    },
    {
      id: 7,
      title: "Island Group Realty",
      subtitle: "Real estate website for Island Group Realty.",
      imageUrl: "/images/isellkw.jpg",
      largeImageUrl: ["/images/isellkw.png"],
      url: "https://isellkw.com/",
    },
    {
      id: 8,
      title: "Mazen Homes",
      subtitle: "Real estate website for Mazen Homes.",
      imageUrl: "/images/mazenHomes.jpg",
      largeImageUrl: ["/images/mazenHomes.png"],
      url: "https://mazenhomes.com/",
    },
    {
      id: 9,
      title: "DevM Real Estate",
      subtitle: "Personal project consisting for a real estate listing application allowing users to create, update and delete their own properties.",

      imageUrl: "/images/devm.jpg",
      largeImageUrl: ["/images/devm.png"
        , "/images/devmDashboard.png"],
      url: "https://github.com/Bcansdale/devMRealEstate",
    },
    {
      id: 10,
      title: "Timeslot",
      subtitle: "Scheduling application for businesses to manage their appointments and employees.",
      imageUrl: "/images/timeslot.jpg",
      largeImageUrl: ["/images/timeslot.png",
        "/images/timeslotDashboard.png",
        "/images/timeslotscheduler.png"],
      url: "https://github.com/Bcansdale/timeslot",
    },
    {
      id: 11,
      title: "Tic-Tac-Toe",
      subtitle: "Interactive tic-tac-toe game.",
      imageUrl: "/images/tictactoe.jpg",
      largeImageUrl: ["/images/tictactoe.png"],
      url: "https://github.com/Bcansdale/reactTicTacToe",
    },
  ],

  photography: [
    {
      id: 1,
      title: "Tetons",
      subtitle: "Jackson Hole, Wyoming",
      imageUrl: "/images/blogpost1.png",
      largeImageUrl: ["/images/blogpost1.png"],
      url: "",
    }
  ],

  experience: {
    workingExperience: [
      {
        id: 1,
        year: "2025 - Present",
        position: "Web/Software Developer",
        company: "Warmzone LLC",
        details:
            "",
      },
      {
        id: 1,
        year: "2024 - 2025",
        position: "Full-Stack Web Developer",
        company: "Blupoint Media LLC",
        details:
            "",
      },
      {
        id: 2,
        year: "2020 - Present",
        position: "Freelancer",
        company: "Freelance",
        details:
            "",
      },
      {
        id: 3,
        year: "2011 - 2024",
        position: "Publix Supermarkets",
        company: "Department Manager",
        details:
            "",
      },
    ],
    educationExperience: [
      {
        id: 1,
        year: "Expected 2027",
        graduation: "Bachelor of Science - Professional Pilot",
        university: "Utah Valley University",
        details:
            "",
      },
      {
        id: 2,
        year: "Expected 2026",
        graduation: "Bachelor of Applied Science - Technology Development and Management",
        university: "St. Petersburg College",
        details:
            "",
      },
      {
        id: 3,
        year: "2025",
        graduation: "Associates of Science - Web Development",
        university: "St. Petersburg College",
        details:
            "",
      },
      {
        id: 4,
        year: "2024",
        graduation: "Certificate of Completion - Web Development Specialist",
        university: "St. Petersburg College",
        details:
            "",
      },
      {
        id: 5,
        year: "2024",
        graduation: "Certificate of Completion - Web Developer Bootcamp",
        university: "DevMountain",
        details:
            "",
      },
      {
        id: 6,
        year: "2017",
        graduation: "Associates of Science - Biology",
        university: "Florida Southwestern State College",
        details:
            "",
      },
    ],
  },

  blogs: [
    {
      id: 1,
      title: "My Journey becoming a Web Developer.",
      featuredImage: "/images/blogpost1.jpg",
      filesource: "../../blog/my-journey.md",
      createDay: "9",
      createMonth: "March",
      createYear: "2025",
    },
    // {
    //     id: 2,
    //     title: "Installing NodeJS on your device.",
    //     featuredImage: "/images/blog-image-2.jpg",
    //     filesource: "../../blog/installing-nodejs-on-your-device.md",
    //     createDay: "20",
    //     createMonth: "February",
    //     createYear: "2020",
    // },
    // {
    //     id: 3,
    //     title: "UI/UX design starter with Adobe XD.",
    //     featuredImage: "/images/blog-image-3.jpg",
    //     filesource: "../../blog/uiux-design-starter-with-adobe-xd.md",
    //     createDay: "20",
    //     createMonth: "February",
    //     createYear: "2020",
    // },
    // {
    //     id: 4,
    //     title: "Boost your post for increasing sales.",
    //     featuredImage: "/images/blog-image-4.jpg",
    //     filesource: "../../blog/boost-your-post-for-increasing-sales.md",
    //     createDay: "20",
    //     createMonth: "February",
    //     createYear: "2020",
    // },
    // {
    //     id: 5,
    //     title: "Difference between GatsbyJS & NextJS.",
    //     featuredImage: "/images/blog-image-5.jpg",
    //     filesource: "../../blog/difference-between-gatsbyjs-and-nextjs.md",
    //     createDay: "20",
    //     createMonth: "February",
    //     createYear: "2020",
    // },
    // {
    //     id: 6,
    //     title: "How to choose javascript framework for project.",
    //     featuredImage: "/images/blog-image-6.jpg",
    //     filesource:
    //         "../../blog/how-to-choose-javascript-framework-for-project.md",
    //     createDay: "20",
    //     createMonth: "February",
    //     createYear: "2020",
    // },
  ],

  contactInfo: {
    phoneNumbers: ["239-233-5539"],
    emailAddress: ["brandon.cansdale@phaseonemedia.io"],
    address: "Salt Lake City, Utah, United States",
  },
};

Mock.onGet("/api/information").reply((config) => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply((config) => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply((config) => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply((config) => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply((config) => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/photography").reply((config) => {
  const response = database.photography;
  return [200, response];
});

Mock.onGet("/api/experience").reply((config) => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply((config) => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply((config) => {
  const response = database.contactInfo;
  return [200, response];
});
